function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { definePropType } from "@types-vue/props";
import { defineComponent, ref } from "vue";
import { JobType, JobStatus } from "@pt/enums/jobs";
import { JobTypeOption, JobStatusOption, DemandOrderOption } from "./utils";
import PtButton from "@com/pt-components/pt-button/index.vue";
import { playTurboHostList } from "@/config/host";
import { NODE_ENV } from "@com/config/env";
import ShowTipContent from "@com/components/show-tips-content/index.vue";
import { getDmakerCustomInfo } from "@/api/creative/custom.js";
import _ from "lodash";
import { openVe, openVeReplace } from "@ve-pro/utils/open";
import { getProjectInfo } from "@ve-pro/api/project";
import { openAiBanner } from "@ai/utils/open";
export default defineComponent({
    props: {
        data: {
            type: definePropType(Object),
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PtButton: PtButton,
        ShowTipContent: ShowTipContent
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var getStatus = function getStatus(status) {
            var item = null;
            if (props.data.type === JobType.DemandOrder) {
                item = DemandOrderOption.find(function(t) {
                    return t.value === status;
                });
            } else {
                item = JobStatusOption.find(function(t) {
                    return t.value === status;
                });
            }
            switch(status){
                case JobStatus.Running:
                    var _$ref;
                    return {
                        label: (_$ref = item === null || item === void 0 ? void 0 : item.label) !== null && _$ref !== void 0 ? _$ref : "",
                        value: "pending"
                    };
                case JobStatus.Success:
                case JobStatus.PartSuccess:
                    var _$ref1;
                    return {
                        label: (_$ref1 = item === null || item === void 0 ? void 0 : item.label) !== null && _$ref1 !== void 0 ? _$ref1 : "",
                        value: "success"
                    };
                case JobStatus.Failed:
                    var _$ref2;
                    return {
                        label: (_$ref2 = item === null || item === void 0 ? void 0 : item.label) !== null && _$ref2 !== void 0 ? _$ref2 : "",
                        value: "fail"
                    };
                default:
                    var _$ref3;
                    return {
                        label: (_$ref3 = item === null || item === void 0 ? void 0 : item.label) !== null && _$ref3 !== void 0 ? _$ref3 : "",
                        value: "pending"
                    };
            }
        };
        var getJobTitle = function getJobTitle(job) {
            var _$ref;
            var _$ref4;
            return (_$ref4 = (_$ref = JobTypeOption.find(function(t) {
                return t.value === job;
            })) === null || _$ref === void 0 ? void 0 : _$ref.label) !== null && _$ref4 !== void 0 ? _$ref4 : "-";
        };
        var loading = ref(false);
        var PTUrl = playTurboHostList[NODE_ENV];
        var open = function(url) {
            window.open(url, "_blank");
        };
        var handleClick = function() {
            switch(props.data.type){
                case JobType.VeOcr:
                case JobType.VeElimination:
                    loading.value = true;
                    getProjectInfo({
                        id: props.data.project_id
                    }).then(function(p) {
                        var _$ref;
                        if (((_$ref = p.data.data.project) === null || _$ref === void 0 ? void 0 : _$ref.type) === "simple") {
                            openVeReplace(props.data.project_id);
                        } else {
                            openVe(props.data.project_id);
                        }
                        emit("jump");
                    }).finally(function() {
                        loading.value = false;
                    });
                    return;
                case JobType.AigcTask:
                    open("".concat(PTUrl, "/#/my-project/history/ai"));
                    break;
                case JobType.VeRender:
                    open("".concat(PTUrl, "/#/my-project/history/video"));
                    break;
                case JobType.VrecRecording:
                    open("".concat(PTUrl, "/#/my-project/history/record"));
                    break;
                case JobType.DmPush:
                    getDmakerInfo(props.data.project_id).then(function(res) {
                        open("".concat(PTUrl, "/#/creative-service/playable/").concat(res.template_id, "/version/multi?project_id=").concat(props.data.project_id));
                    });
                    break;
                case JobType.GmPush:
                    open("".concat(PTUrl, "/#/my-project/history/playable"));
                    break;
                case JobType.GmDown:
                case JobType.DmDown:
                    if (props.data.jump_url) {
                        window.open(props.data.jump_url, "_blank");
                    }
                    break;
                case JobType.VeSimple:
                    open("".concat(PTUrl, "/#/my-project/history/video"));
                    break;
                case JobType.DemandOrder:
                    var _$ref6, _$ref5;
                    open("".concat(PTUrl, "/#/my-project/playable/").concat((_$ref6 = props.data.ext_data) === null || _$ref6 === void 0 ? void 0 : _$ref6.template_id, "/custom/").concat((_$ref5 = props.data.ext_data) === null || _$ref5 === void 0 ? void 0 : _$ref5.project_id));
                    break;
                case JobType.AiBanner:
                    openAiBanner(props.data.project_id);
                    break;
                case JobType.AvatarVideo:
                    open("".concat(PTUrl, "/#/creative-assets/nl/user_assets"));
                    break;
                default:
                    break;
            }
            emit("jump");
        };
        function getDmakerInfo(id) {
            return _getDmakerInfo.apply(this, arguments);
        }
        function _getDmakerInfo() {
            _getDmakerInfo = // 获取项目信息
            _asyncToGenerator(regeneratorRuntime.mark(function _callee(id) {
                var res, data;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getDmakerCustomInfo({
                                custom_id: id
                            });
                        case 2:
                            res = _ctx.sent;
                            data = _.get(res, "data.data");
                            if (data) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return", Promise.reject());
                        case 6:
                            return _ctx.abrupt("return", data);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getDmakerInfo.apply(this, arguments);
        }
        return {
            loading: loading,
            JobType: JobType,
            JobStatus: JobStatus,
            getStatus: getStatus,
            getJobTitle: getJobTitle,
            handleClick: handleClick
        };
    }
});
